import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export const AnimatedText: React.FC = () => {
  return (
    <>
      <Stack
        width={1}
        direction="row"
        alignItems="center"
        justifyContent="center"
        position="relative"
      >
        <Typography
          variant="h1"
          color="primary.contrastText"
          whiteSpace="nowrap"
          sx={{
            fontSize: {
              md: "9rem",
              sm: "7.5rem",
              xs: "4.5rem",
              // md: "7rem",
            },
          }}
        >
          Write
        </Typography>

        <Typography
          variant="h1"
          color="primary"
          whiteSpace="nowrap"
          sx={{
            fontSize: {
              md: "9rem",
              sm: "7.5rem",
              xs: "4.5rem",
              // md: "7rem",
            },
          }}
        >
          Better
        </Typography>

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0,
            animation: "rectangleAnimation 1s 1 linear",
            animationDirection: "alternate",
            zIndex: 1,
            backgroundColor: "background.default",

            "@keyframes rectangleAnimation": {
              "0%": { left: 0, opacity: 1 },
              "50%": { left: "50%", opacity: 1 },
              "100%": { left: "100%", opacity: 1 },
            },
          }}
        />
      </Stack>

      <Stack
        width={1}
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          justifyContent: {
            md: "flex-end",
            xs: "center",
          },
        }}
      >
        <Typography
          position="relative"
          variant="body1"
          color="primary.contrastText"
          sx={{
            transform: {
              md: "translateX(-102px)",
              sx: "translateX(0)",
            },
          }}
        >
          by Sven Badalyan
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              animation: "revealText 0.3s 1 linear 1s",
              animationFillMode: "forwards",
              zIndex: 1,
              backgroundColor: "background.default",

              "@keyframes revealText": {
                "0%": { left: 0 },
                "50%": { left: "50%" },
                "100%": { left: "100%" },
              },
            }}
          />
        </Typography>
      </Stack>
    </>
  );
};
